function shipFunction() {
  // if ($('[data-shipping-charge]').length > 0) {
    $('body').on('click', '[data-shipping-charge]', function(e) {
      e.preventDefault();
      if ($(this).hasClass('rw-unchecked')) {
        $(this).closest('[data-closest]').find('[data-append-class]').addClass('rw-checked');
        $(this).closest('[data-closest]').find('[data-append-class]').removeClass('rw-unchecked');
//         if ($('.template-cart').length == 0) {
//           Shopify.addItem($(this).attr('data-shipping-charge'));
//         } else {
          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: 'quantity=' + 1 + '&id=' + $(this).attr('data-shipping-charge'),
            dataType: 'json',
            success: function(line_item) {
              if(window.location.href == 'https://magiccandlecompany.com/cart'){
                 window.location.href = '/cart';
              }
            },
            error: function(XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }
          };
          jQuery.ajax(params);
          return false;
//         }
      } else {
        $(this).closest('[data-closest]').find('[data-append-class]').addClass('rw-unchecked');
        $(this).closest('[data-closest]').find('[data-append-class]').removeClass('rw-checked');
//         if ($('.template-cart').length == 0) {
//           Shopify.changeItemNew($(this).attr('data-shipping-charge'));
//         } else {
          var params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + 0 + '&id=' + $(this).attr('data-shipping-charge'),
            dataType: 'json',
            success: function(line_item) {
              if(window.location.href == 'https://magiccandlecompany.com/cart'){
                 window.location.href = '/cart';
              }
            },
            error: function(XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }
          };
          jQuery.ajax(params);
        return false;
//         }
      }
    });
  // }
}
shipFunction();
// if (window.location.href.indexOf('/cart') > -1) {
//   shipFunction();
// } 

// myInterval = setInterval(function() {
//   // console.log($('#CartDrawer').hasClass('drawer--is-open'))
//   if ($('#CartDrawer').hasClass('drawer--is-open')) {
//     setTimeout(function() {
//       shipFunction();
//       clearInterval(myInterval);
//     }, 3000);
//   }
// }, 1000);

$('[name="checkout"]').click(function() {
  if(JSON.stringify(window.theme.cart.items).indexOf('39604686716977') > -1 || JSON.stringify(window.theme.cart.items).indexOf('39653887868977') > -1) {
    window.theme.cart.items.forEach(function(item) {
      if (item.id == 39604686716977) {
        if (item.quantity > 1) {
          var params = {
            type: 'POST',
            url: '/cart/change.js',
            data:  'quantity=' + 1 + '&id=39604686716977',
            dataType: 'json',
            success: function(cart) {
            },
            error: function(XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }
          };
          jQuery.ajax(params);
        }
      }
      if (item.id == 39653887868977) {
        if (item.quantity > 1) {
          var params = {
            type: 'POST',
            url: '/cart/change.js',
            data:  'quantity=' + 1 + '&id=39653887868977',
            dataType: 'json',
            success: function(cart) {
            },
            error: function(XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }
          };
          jQuery.ajax(params);
        }
      }
    });
  }
});